import { render, staticRenderFns } from "./FeCascader.vue?vue&type=template&id=54ffe115&scoped=true&"
import script from "./FeCascader.vue?vue&type=script&lang=js&"
export * from "./FeCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffe115",
  null
  
)

export default component.exports